import { render, staticRenderFns } from "./BuyLife.vue?vue&type=template&id=38a6fd12&"
import script from "./BuyLife.vue?vue&type=script&lang=js&"
export * from "./BuyLife.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports